(function () {
    'use strict';
    var app = angular.module('laekkerAI.tablet');

    app.controller(
        'TabletTabletFooterController',
        [
            function () {
            }]);
}());